import { DownloadVideo } from '@bpm-web-app/api-client';

import useSWR from 'swr';

export function useFeaturedVideos(isEnabled = true) {
    const { data, error, mutate } = useSWR(['download-get-featured-videos', { isEnabled, persist: true }], () => (isEnabled ? DownloadVideo.getFeaturedVideos() : null)
    );

    return {
        data,
        isLoading: !error && !data,
        error,
        mutate,
    };
}

export const useVideos = () => {
    const { data, error } = useSWR<Awaited<ReturnType<typeof DownloadVideo['getVideos']>>>(
        [
            'get-videos',
            {
                persist: true,
            },
        ],
        () => DownloadVideo.getVideos({})
    );

    return {
        data: data?.data,
        isLoading: !error && !data,
        error,
    };
};

export const useVideoBySlug = (slug: string) => {
    const { data, error } = useSWR<Awaited<ReturnType<typeof DownloadVideo['getVideoBySlug']>>>(
        [
            'get-video-slug',
            {
                slug,
                persist: true,
            },
        ],
        () => DownloadVideo.getVideoBySlug(slug)
    );

    return {
        data: data?.data,
        isLoading: !error && !data,
        error,
    };
};

export const useVideosByCategory = (slug?: string) => {
    const { data, error } = useSWR<Awaited<ReturnType<typeof DownloadVideo['getVideosForCategory']>> | null>(
        [
            'get-video-categories-slug',
            {
                slug,
                persist: true,
            },
        ],
        () => slug ? DownloadVideo.getVideosForCategory(slug) : null
    );

    return {
        data: data?.data,
        isLoading: !error && !data,
        error,
    };
};
